import { AusActions } from "@aus/Store/AusState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<
    {
        intialState?: boolean;
    },
    DispatchProp<AusActions>
>;

export const DispatchUpdatedAccountSettings: HandlerType = props => {
    props.dispatch({
        type: "Update/DefaultToOneTimeShipTo",
    });
};

export const chain = [DispatchUpdatedAccountSettings];

const defaultToOneTimeShipTo = createHandlerChainRunner(chain, "DefaultToOneTimeShipTo");
export default defaultToOneTimeShipTo;